/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
const factory = function (Api) {
  class FtApi extends Api {
    constructor() {
      super('ft');
    }
  }

  return new FtApi();
};

module.exports = factory;
